import information from '@/views/mainContent/information'
import basemenu from '@/views/mainContent/information/base'
import review from '@/views/mainContent/information/review'
import personinfo from '@/views/mainContent/information/personinfo'
import addform1 from '@/views/mainContent/information/addForm/index1'
import addform2 from '@/views/mainContent/information/addForm/index2'
import addform3 from '@/views/mainContent/information/addForm/index3'
import addform4 from '@/views/mainContent/information/addForm/index4'
import addform5 from '@/views/mainContent/information/addForm/index5'
import addform6 from '@/views/mainContent/information/addForm/index6'
import addform7 from '@/views/mainContent/information/addForm/index7'
import library from '@/views/mainContent/information/library/index'
import libraryadd from '@/views/mainContent/information/library/listNew/index'
import specialist from '@/views/mainContent/information/specialist'
import addspecialist from '@/views/mainContent/information/specialist/listNew'
import libraryUser from '@/views/mainContent/information/libraryUser/index'
import addlibraryUser from '@/views/mainContent/information/libraryUser/listNew/index'
import users from '@/views/mainContent/information/user/index'
import adduser from '@/views/mainContent/information/user/listNew/index'
import progress from '@/views/mainContent/information/processManagement/index'
import selectdata from '@/views/mainContent/information/pfcx/index'
import list from '@/views/mainContent/information/list/index'

let standardManageRouter = {
  path: '/meterial',
  component: information,
  exact: true,
  children: [
    {
      path: '/base',
      component: basemenu,
      exact: true,
    },
    {
      path: '/innovationReview',
      component: review,
      exact: true,
    },
    {
      path: '/innovationItem1',
      component: addform1,
      exact: true,
    },
    {
      path: '/innovationItem2',
      component: addform2,
      exact: true,
    },
    {
      path: '/innovationItem3',
      component: addform3,
      exact: true,
    },
    {
      path: '/innovationItem4',
      component: addform4,
      exact: true,
    },
    {
      path: '/innovationItem5',
      component: addform5,
      exact: true,
    },
    {
      path: '/innovationItem6',
      component: addform6,
      exact: true,
    },
    {
      path: '/innovationItem7',
      component: addform7,
      exact: true,
    },
    {
      path: '/personinfo',
      component: personinfo,
      exact: true,
    },
    {
      path: '/library',
      component: library,
      exact: true,
    },
    {
      path: '/libraryadd',
      component: libraryadd,
      exact: true,
    },
    {
      path: '/specialist',
      component: specialist,
      exact: true,
    },
    {
      path: '/addspecialist',
      component: addspecialist,
      exact: true,
    },
    { //用户管理
      path: '/libraryUser',
      component: libraryUser,
      exact: true,
    },
    { //用户管理
      path: '/addlibraryUser',
      component: addlibraryUser,
      exact: true,
    },
    { //用户管理
      path: '/user',
      component: users,
      exact: true,
    },
    { //用户管理
      path: '/adduser',
      component: adduser,
      exact: true,
    },
    {
      path: '/progress',
      component: progress,
      exact: true,
    },
    {
      path: '/dataselect',
      component: selectdata,
      exact: true,
    },
    {
      path: '/list',
      component: list,
      exact: true,
    },
  ]
}
export default standardManageRouter
